import { useState } from 'react';
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap"
import { Link } from "react-router-dom"
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import Employees from './Employees/Employees';
import Pictures from './Pictures/Pictures';
import { useForm } from "react-hook-form";
import { ContactUs } from '../service/api.service';
import { Testimonial } from '../common/Testimonials';

const Home = () => {
    const [show, setShow] = useState(false);
    const [showMindReset, setShowMindReset] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmitContactUs = (data) => {
        setIsLoading(true);
        const formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        ContactUs(formData).then((res) => {
            alert("Email send successfully!");
            reset();
            setIsLoading(false);
        }).catch(err => {
            alert("Oops! An error occurred, Please try again after some time!");
            setIsLoading(false);
        })
    }

    return (
        <>
            {/* hero section starts here */}
            <section className="hero-section" id='top'>
                <Container>
                    <Row>
                        <Col md={8} lg={6}>
                            <div className="hero-content-section">
                                <h1>Boost Your Team's Productivity</h1>
                                <h1> with <span className="hightlight-txt">MindReset</span></h1>
                                <h6>Reduce burnout and improve overall well-being in just 2 minutes a day </h6>
                                {/* <Button className="get-started-btn">Get Started</Button> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* hero section end here */}
            {/* Burnout section starts here */}
            <section className="burnout-section common-padding" id="burnout-problem">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <div className="burnout-content-box">
                                <h3 className="subheading">The <span className="hightlight-txt">Burnout</span> Problem</h3>
                                <ul>
                                    <li>Burnout has become a growing issue in today's fast-paced work environment, impacting employee productivity, morale, and overall health. </li>
                                    <li>Companies that fail to address burnout experience increased absenteeism, high employee turnover, and decreased job satisfaction.</li>
                                    <li>By proactively addressing burnout, your organisation can foster a healthier, more engaged, and productive workforce. </li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="burnout-content-imf">
                                <img src={require("../assets/images/burnout-img.png")} alt="img" />
                            </div>
                        </Col>
                    </Row>
                    <Row className="align-items-center margin-top-main" id="about-us">
                        <Col md={6}>
                            <div className="burnout-content-imf">
                                <img src={require("../assets/images/teams-pic.png")} alt="img" />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="burnout-content-box">
                                <h3 className="subheading">Introducing <span className="hightlight-txt">MindReset</span> For Teams</h3>
                                <ul className="mb-3">
                                    <li>MindReset is a mental wellness app specifically designed to help busy professionals improve their mental health in just 2 minutes a day. </li>
                                    <li>With programs targeting stress, anxiety, depression, insomnia, fatigue, and trauma, MindReset offers a convenient and effective solution to combat burnout and promote a healthy work-life balance. </li>
                                </ul>
                                <Link >Contact Us <i className="fa-solid fa-chevron-right"></i></Link>
                            </div>
                        </Col>
                    </Row>
                    <Row className="align-items-center margin-top-main" id="solution">
                        <Col md={6}>
                            <div className="burnout-content-box">
                                <h3 className="subheading">Proven <span className="hightlight-txt">Results</span></h3>
                                <img src={require("../assets/images/proven-1.png")} alt="img" className="mt-2" />
                                <ul className="mt-0">
                                    <li>A pilot study conducted at <Link to="https://www.wincanton.co.uk/" target="_blank" className="mt-0"><img src={require("../assets/images/wincanton-logo.svg").default} alt="img" className="wincanton-logo" /></Link>  company demonstrated the effectiveness of MindReset in reducing burnout. After just one month of using the app, employees experienced a significant reduction in OLBI Exhaustion (58% to 36%) and Disengagement (34% to 21%). <Link className="mt-0" onClick={handleShow}>OLBI</Link></li>
                                </ul>
                                <img src={require("../assets/images/provan-2.png")} alt="img" className="mt-2" />
                                <ul className="mt-0">
                                    <li>Every measured trait in the OLBI questionnaire showed positive change, highlighting the impact of MindReset on overall well-being and productivity. <Link className="mt-0" onClick={handleShow}>OLBI</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="burnout-content-imf">
                                <img src={require("../assets/images/result.png")} alt="img" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* Burnout section end here */}
            {/* ROI  calculator section starts */}
            <section className="common-padding roi-calculator-section" id='roi-main-calculator'>
                <Container>
                    <Row className="align-items-center">

                        <Col md={6}>
                            <div className='integrated-calclator text-center'>
                                <Employees setShowMindReset={setShowMindReset} showMindReset={showMindReset} />
                            </div>
                            {/* <div className="burnout-content-imf text-center">
                                <Link>
                                    <img src={require("../assets/images/calculator.png")} alt="img" />
                                </Link>
                            </div> */}
                        </Col>
                        {/* <Col md={12} className='mobile-view'>
                            <div className='integrated-pictures'>
                                {showMindReset &&
                                    <Pictures />
                                }
                            </div>
                        </Col> */}
                        <Col md={6}>
                            <div className="burnout-content-box">
                                <h3 className="subheading"><span className="hightlight-txt">ROI</span> Calculator</h3>
                                <ul>
                                    <li>Discover the potential savings and return on investment your organization can achieve by implementing MindReset for your team. </li>
                                    <li>Our ROI calculator allows you to input your team size and salaries, providing an estimate of the financial impact of burnout and the potential savings from using MindReset. </li>
                                </ul>
                            </div>
                        </Col>
                        {/* <Col md={12} className='desktop-view'>
                            <div className='integrated-pictures'>
                                {showMindReset &&
                                    <Pictures />
                                }
                            </div>
                        </Col> */}

                    </Row>
                </Container>
            </section>
            {/* ROI  calculator section ends */}
            {/* Dashboard calculator section starts */}
            <section className="roi-calculator common-padding">
                <Container>
                    <div className="text-center">
                        <h3 className="subheading mb-3 contact-us-headings"><span className="hightlight-txt">Dashboard</span> For Team Leaders</h3>
                        <img src={require("../assets/images/dashboard.png")} alt="img" className="mb-5" />
                        <p>MindReset for Teams includes a comprehensive dashboard for team leaders, allowing you to monitor anonymous usage stats and track your team's overall well-being. This valuable insight can help you identify trends, support your team's mental health, and create a more resilient and productive workforce.</p>
                    </div>
                </Container>
            </section>
            {/* Dashboard calculator section ends */}
            {/* Pricing section starts */}
            <section className="common-padding roi-calculator-section" id="pricing">
                <Container>
                    <Row className="align-items-center">

                        <Col md={6}>
                            <div className="burnout-content-imf">
                                <img src={require("../assets/images/pricing.png")} alt="img" />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="burnout-content-box">
                                <h3 className="subheading text-center"><span className="hightlight-txt">Pricing</span></h3>
                                {/* <ul className="mb-3">
                                    <li>MindReset for Teams offers flexible pricing options to suit the needs of your organization. </li>
                                    <li>Invest in your team's mental health and unlock the potential savings and productivity gains from reducing burnout. </li>
                                    <li>Contact us for detailed pricing information and to discuss the best solution for your organization. </li>
                                </ul>
                                <Link >Contact Us <i className="fa-solid fa-chevron-right"></i></Link> */}
                                <Row>
                                    <Col md={6} className='mb-3'>
                                        <div className='pricng-box'>
                                            <div className='inner-pricing-page'>
                                                <img src={require("../assets/images/standar-icon.svg").default} alt="img" />
                                                <h5>£9.99</h5>
                                            </div>
                                            <div className='inner-pricing-page-body'>
                                                <h4>Standard App Store Price</h4>
                                                <p></p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <div className='pricng-box'>
                                            <div className='inner-pricing-page'>
                                                <img src={require("../assets/images/standar-icon-4.svg").default} alt="img" />
                                                <h5>£5.99</h5>
                                            </div>
                                            <div className='inner-pricing-page-body'>
                                                <h4>Small Size Companies</h4>
                                                <p>(10-50)</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='pricng-box'>
                                            <div className='inner-pricing-page'>
                                                <img src={require("../assets/images/standar-icon-2.svg").default} alt="img" />
                                                <h5>£3.99</h5>
                                            </div>
                                            <div className='inner-pricing-page-body'>
                                                <h4>Medium Size Companies</h4>
                                                <p>(51-1000)</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='pricng-box'>
                                            <div className='inner-pricing-page'>
                                                <img src={require("../assets/images/standar-icon-3.svg").default} alt="img" />
                                                <h5>£2.99</h5>
                                            </div>
                                            <div className='inner-pricing-page-body'>
                                                <h4>Large Size Companies</h4>
                                                <p>(1001+)</p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/*  Pricing section ends */}
            {/* Testimonials section starts */}
            <section className="testimonial-section common-padding">
                <Container>
                    <div className="testimonial-box">
                        <h3 className="subheading text-center mb-4"><span className="hightlight-txt">Testimonials</span></h3>
                        <Swiper
                            cssMode={true}
                            navigation={true}
                            pagination={true}
                            mousewheel={true}
                            keyboard={true}
                            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                            className="mySwiper"
                        >
                            {Testimonial.map((data, i) => 
                                <SwiperSlide key={i}>
                                    <div className='swiper-outer'>
                                        <h5><b>{data.name}</b></h5>
                                        <h4>- {data.detail}</h4>
                                        <div className='ratings'>
                                        {data.stars && Array.from({ length: data.stars }).map((_, index) => (
                                            <i key={index} className="fa-solid fa-star"></i>
                                        ))}
                                        </div>
                                        <p>"{data.feedback}"</p>
                                    </div>
                                </SwiperSlide>
                            )}
                        </Swiper>
                    </div>
                </Container>
            </section>
            {/* Testimonials section ends */}
            {/* contact us section starts */}
            <section className='contact-us-section common-padding roi-calculator-section' id="contact-us">
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={12} lg={8}>
                            <div className='contact-us-box text-center mb-4'>
                                <h3 className="subheading">Ready to experience the benefits of <span className="hightlight-txt">MindReset </span>for your team?</h3>
                                <p>Contact us today for more information or to schedule a demo. Together, we can create a healthier, more productive workforce.</p>
                            </div>
                            <Row className='justify-content-center'>
                                <Col md={12} lg={8}>
                                    <Form onSubmit={handleSubmit(onSubmitContactUs)}>
                                        <Form.Group className="mb-3">
                                            <Form.Control type="email" placeholder="Email" {...register("email", { required: "Email is required" })} />
                                            {errors.email && <span className="err-msg">{errors.email.message}</span>}
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Control type="text" placeholder="Subject" {...register("subject", { required: "Subject is required" })} />
                                            {errors.subject && <span className="err-msg">{errors.subject.message}</span>}
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Control as="textarea" rows={3} placeholder="Message" {...register("body", { required: "Message is required" })} />
                                            {errors.body && <span className="err-msg">{errors.body.message}</span>}
                                        </Form.Group>
                                        <Form.Group className="mb-3 text-right mt-5">
                                            <Button type='submit' className="get-started-btn" disabled={isLoading}>Send Message</Button>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* contact us section starts */}

            {/* modal start here */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h4>About OLBI</h4>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='olbi-text'>
                        OLBI (Oldenburg Burnout Inventory)   is a self-report measure used to assess the severity of work-related burnout. OLBI measures emotional exhaustion, cynicism,
                        and reduced professional efficacy. It is a reliable and valid measure, as multiple studies have used it to assess populations of workers in high stress occupations, such as healthcare,
                        education, social services, or industrial work.
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer> */}
            </Modal>
            {/* modal end here */}
        </>
    )
}
export default Home